"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var InjectedStyledComponent_1 = require("../../../../shared/InjectedStyledComponent");

exports.default = InjectedStyledComponent_1.InjectedStyledComponent('div', 'base', 'list', ['lastContent']);